var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376,81.4L341.7,155H204.3L161,247.8h-38.8c0.3-4.6,1.2-9.3,2.7-13.8c3.7-11.2,10.7-20.4,19.5-27c2.3,2.6,4.4,5.5,6.3,8.5 c0.3,0.5,0.9,0.4,1.1,0c0,0,0,0,0,0l62.6-134.2H376z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8,276.6c-3.9,7.8-9.5,14.5-16.3,19.6c-5.7-6.6-10.2-14.3-13.1-23.1c-2-5.9-3.1-11.8-3.4-17.7h38.6 C63.1,262.7,61.2,269.9,57.8,276.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1,255.4v64.2c-15.8-0.9-30.7-7.3-42.3-17.9c7.4-5.7,13.4-13.1,17.8-21.7c3.9-7.8,6.1-16.1,6.6-24.6H89.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9,234c1.5,4.5,2.4,9.2,2.7,13.8H25c0.8-15.1,6.7-29.4,16.5-40.7C50.2,213.7,57.1,222.9,60.9,234"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1,183.7v64.2H71.2c-0.3-5.4-1.4-10.9-3.1-16.2c-4.1-12.4-11.7-22.6-21.3-30c6.9-6.4,15.2-11.4,24.7-14.6 C77.3,185.1,83.2,184,89.1,183.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.6,247.8H96.7v-64.2c15.8,0.9,30.8,7.2,42.4,17.9c-9.9,7.6-17.3,18-21.4,30.1C115.9,237,114.9,242.4,114.6,247.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.1,301.8c-6.9,6.3-15.2,11.3-24.6,14.5c-5.9,2-11.9,3.1-17.8,3.4v-64.2h17.8c0.5,8.5,2.7,16.8,6.6,24.6 C125.5,288.7,131.6,296.1,139.1,301.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M161,255.4c-0.8,15.1-6.7,29.5-16.6,40.9c-6.9-5.1-12.5-11.8-16.4-19.7c-3.4-6.7-5.3-13.9-5.8-21.2H161z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUta);
export default __webpack_public_path__ + "static/media/UTA.e7681b1548e188dfdc5abb5c8ac7b16d.svg";
export { ForwardRef as ReactComponent };